export const MOBILE_WIDTH = 1000;
export const SCROLL_VALUE = 35;